import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtCurrentPerformanceChartMetric {
    metricID: number;
    displayOrder: number;
    metricName: string;
    variance: number;
}

interface CurrentPerformanceChartMetric {
    metricName: string;
    variance: number;
}

export interface CurrentPerformanceChart {
    d3: { options?: any; data: any };
}

class CurrentPerformanceChartMetricModelTransformer
    implements
        ModelTransformer<
            CurrentPerformanceChartMetric,
            ExtCurrentPerformanceChartMetric
        >
{
    transform(
        model: ExtCurrentPerformanceChartMetric,
    ): CurrentPerformanceChartMetric {
        return {
            metricName: model.metricName,
            variance: model.variance,
        };
    }
}

class CurrentPerformanceChartMetricModelSetTransformer extends ModelSetTransformer<
    CurrentPerformanceChartMetric,
    ExtCurrentPerformanceChartMetric
> {
    protected newTransformer(): ModelTransformer<
        CurrentPerformanceChartMetric,
        ExtCurrentPerformanceChartMetric
    > {
        return new CurrentPerformanceChartMetricModelTransformer();
    }

    transform(
        model: ExtCurrentPerformanceChartMetric[],
    ): CurrentPerformanceChartMetric[] {
        return super.transform(
            model.sort((a, b) => a.displayOrder - b.displayOrder),
        );
    }
}

export class CurrentPerformanceChartModelTransformer
    implements
        ModelTransformer<
            CurrentPerformanceChart,
            ExtCurrentPerformanceChartMetric[]
        >
{
    transform(
        model: ExtCurrentPerformanceChartMetric[],
    ): CurrentPerformanceChart {
        const metrics =
            new CurrentPerformanceChartMetricModelSetTransformer().transform(
                model,
            );
        return {
            d3: {
                data: [
                    {
                        values: metrics.map((value) => {
                            return {
                                x: value.metricName,
                                y: value.variance,
                            };
                        }),
                    },
                ],
            },
        };
    }
}

export function validateCurrentPerformanceChart(
    model: CurrentPerformanceChart,
): void {
    const valid = model != null && model.d3.data[0].values.length !== 0;
    if (!valid) {
        throw new Error('CurrentPerformanceChart not valid');
    }
}
